import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MatDialogRef} from '@angular/material/dialog';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideRouter, Router, withDebugTracing} from '@angular/router';
import {AccountManagementModule} from '@modules/account-management';
import {ActivityEditionModule} from '@modules/activity-edition';
import {AuthenticationModule} from '@modules/authentication';
import {BrowserTestModule} from '@modules/browser-test';
import {CommunicationCenterModule, CommunicationCenterService} from '@modules/communication-center';
import {FaqModule} from '@modules/faq';
import {LessonEditionModule} from '@modules/lesson-edition';
import {MindmapModule} from '@modules/mindmap';
import {NotepadModule} from '@modules/notepad';
import {NotificationModule} from '@modules/notification';
import {FuseModule} from 'fuse-core/fuse.module';
import {DatacardService} from 'shared/datacard.service';
import {EventService} from 'shared/event.service';
import {TranslateModule} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import {Angulartics2Module} from 'angulartics2';
import {NgHcaptchaModule} from 'ng-hcaptcha';
import {OctopusConnectModule} from 'octopus-connect';
import {IsAllowedBySettings, IsDefaultOrDefaultLoginRoute, IsUserAnonymous, IsUserAuthorisedByRoleGuard, IsUserLogged} from '../../../../src/app/guards';
import {IsUserNotLogged} from '../../../../src/app/guards/is-not-user-logged.class';
import {HeaderModule} from '../../../../src/app/header/header.module';
import {NavigationModule} from '../../../../src/app/navigation/navigation.module';
import {layoutConfig} from '../../../../src/app/settings/mathia';
import {SvgIconList} from '../../../../src/app/themes/mathia/svgIconList';
import {TralaTranslationLoaderService} from '../../../../src/app/trala-translation-loader.service';
import { routes } from './app.routes';
import {ServiceInstantiator} from "./service-instantiator.class";
import {MathiaOctopusConfig} from "./mathia.octopus-config";
import {ActivitiesModule, LessonsModule} from "@modules/activities";
import {DashboardModule} from "@modules/dashboard";
import {GraphMathiaModule} from "@modules/graph-mathia";

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes,
            // withDebugTracing(),
        ),
        provideAnimations(),
        provideHttpClient(),
        importProvidersFrom(
            AccountManagementModule.forRoot(),
            ActivitiesModule.forRoot(),
            ActivityEditionModule.forRoot(),
            Angulartics2Module.forRoot(),
            AuthenticationModule.forRoot(),
            BrowserTestModule.forRoot({
                desktopSize: {
                    minWidth: 1024,
                    minHeight: 768,
                },
                browsersBlackList: [
                    {
                        name: 'ie',
                        minVersion: '11',
                    },
                    {
                        name: 'chrome',
                        minVersion: '72',
                    },
                    {
                        name: 'firefox',
                        minVersion: '65',
                    },
                    {
                        name: 'edge',
                        minVersion: '16',
                    },
                    {
                        name: 'safari',
                        minVersion: '10',
                    },
                ],
            }),
            CommunicationCenterModule.forRoot(),
            DashboardModule.forRoot(),
            FaqModule.forRoot(),
            FuseModule.forRoot(layoutConfig),
            GraphMathiaModule.forRoot(),
            HeaderModule.forRoot(),
            LessonEditionModule.forRoot(),
            LessonsModule.forRoot(),
            MindmapModule.forRoot(),
            NavigationModule.forRoot(),
            NgHcaptchaModule.forRoot({
                siteKey: '8858d7eb-82d8-425e-9d74-e114ceca737b',
                // languageCode: 'de' // optional, will default to browser language
            }),
            NotepadModule.forRoot(),
            NotificationModule.forRoot(),
            OctopusConnectModule.forRoot(MathiaOctopusConfig),
            TranslateModule.forRoot(),
        ),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        provideAppInitializer(() => {
        const initializerFn = ((_) => () => {
            })(inject(Sentry.TraceService));
        return initializerFn();
      }),
        IsDefaultOrDefaultLoginRoute,
        IsUserLogged,
        IsUserNotLogged,
        IsUserAuthorisedByRoleGuard,
        IsUserAnonymous,
        IsAllowedBySettings,
        TralaTranslationLoaderService,
        SvgIconList,
        CommunicationCenterService,
        DatacardService,
        EventService,
        ServiceInstantiator,
        {
            provide: MatDialogRef,
            useValue: {}
        },
        {
            provide: MatBottomSheetRef,
            useValue: {}
        }
    ]
};


